import { Stack, styled } from '@mui/material'
import SelectedIcon from 'assets/icons/selected-3.svg'
import { Button } from 'components/common/Button'
import { NewFlexContainer } from 'components/common/common.style'
import { unifiedColors } from 'styles/colors'
import { media } from 'styles/responsive'
import { theme } from 'styles/theme'

export const MapContainer = styled(NewFlexContainer)`
  .mapboxgl-popup {
    max-width: max-content !important;
  }
  .mapboxgl-popup-tip {
    display: none;
  }
  .mapboxgl-popup-close-button {
    display: none;
  }
  .mapboxgl-popup-content {
    padding: 0;
    border-radius: 24px;
    overflow: hidden;
  }
  ${media.maxWidth.md} {
    position: fixed;
    display: flex;
    flex-direction: column;
    background-color: ${unifiedColors.surface.subdued};
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 101;
  }
`

export const Selected = styled(SelectedIcon)`
  height: 36px;
  margin-bottom: 24px;
  transition: transform 0.3s ease;
  ${media.minWidth.md} {
    &:hover {
      transform: scale(1.1);
    }
  }
`

export const FiltersContainer = styled(Stack)`
  ${media.maxWidth.md} {
    width: 100%;
  }
`

export const CrosshairsButton = styled(Button)`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1000;
  height: 38px;
  padding: 9px;
  background-color: ${theme.palette.surface.default};
  &:hover {
    background-color: ${unifiedColors.surface.secondary};
  }
`
interface SearchInZoneButtonProps {
  $searchInZoneVisible: boolean
}

export const SearchInZoneButtonContainer = styled(
  Stack
)<SearchInZoneButtonProps>`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 10px;
  opacity: ${({ $searchInZoneVisible }) => ($searchInZoneVisible ? 1 : 0)};
  transition: opacity 0.3s ease;
  white-space: nowrap;
`

export const HideMapButton = styled(Button)`
  position: absolute;
  top: 10px;
  left: 10px;
  height: 38px;
  padding: 9px;
  z-index: 1000;
  background-color: ${theme.palette.surface.default};
`

export const ExpandButton = styled(HideMapButton)``

export const ZoomInButton = styled(HideMapButton)`
  border-bottom-left-radius: initial;
  border-bottom-right-radius: initial;
  right: 10px;
  left: unset;
  top: 58px;
`

export const ZoomOutButton = styled(HideMapButton)`
  border-top-left-radius: initial;
  border-top-right-radius: initial;
  left: unset;
  right: 10px;
  top: 95px;
`
